import { getPendingRefillsDetailed } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  GetPendingRefillsDetailedParams,
  RefillDetailedPagedListResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchPendingRefillsDetailed(
  params: GetPendingRefillsDetailedParams | undefined,
  signal?: AbortSignal
): Promise<RefillDetailedPagedListResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await getPendingRefillsDetailed(params, config);
  return lotusHealthZod.getPendingRefillsDetailedResponse.parse(
    response.data
  ) as RefillDetailedPagedListResponseT;
}
